import angular from 'angular';
import * as $ from 'jquery';

angular.module('webTools').factory('ModalWindow', ['$rootScope', '$compile', '$timeout', 'File', 'Folder', 'Project',
    function ($rootScope, $compile, $timeout, File, Folder, Project) {
        return {
            openConfirmation: function(dialogText, successCallback, cancelCallback) {
                var kendoWindow = $('<div id="wtConfirmation" />').kendoWindow({
                    resizable: false,
                    modal: true,
                    close: function(e) {
                        kendoWindow.data("kendoWindow").destroy();
                    },
                    activate: function() {
                        $('.k-overlay').attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');

                        $('#wtConfirmation').parent().attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');
                    }
                });

                kendoWindow.data("kendoWindow")
                    .content('<p style="text-align: center;padding: 5px 10px;">' + dialogText + '</p>' +
                              '<div style="width:100%;text-align:center;">' +
                                '<div class="confirm-ok">Yes</div>' +
                                '<div class="confirm-cancel">No</div>' +
                                '</div>')
                    .center().open();

                    var off = $rootScope.$on('$routeChangeSuccess', function(e, data) {
                        if(kendoWindow.data("kendoWindow")) {
                            kendoWindow.data("kendoWindow").close().destroy();
                        }
                        off();
                    })

                kendoWindow
                    .find(".confirm-ok, .confirm-cancel")
                        .click(function() {
                            if ($(this).hasClass("confirm-ok")) {
                                successCallback();
                            } else if ($(this).hasClass("confirm-cancel")) {
                                if (cancelCallback) { cancelCallback() };
                            }

                             kendoWindow.data("kendoWindow").close().destroy();
                        })
                        .end()
            },
            openNotification: function(dialogText, callback) {
                var kendoWindow = $('<div id="wtNotification" />').kendoWindow({
                    resizable: false,
                    modal: true,
                    close: function(e) {
                        kendoWindow.data("kendoWindow").destroy();
                    },
                    activate: function () {
                        $('.k-overlay').attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');

                        $('#wtNotification').parent().attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');
                    }
                });

                kendoWindow.data("kendoWindow")
                    .content('<p style="text-align: center;padding: 0 10px;">' + dialogText + '</p>' +
                              '<div style="width:100%;text-align:center;">' +
                                '<div class="confirm-ok">OK</div>' +
                                '</div>')
                    .center().open();

              if (callback) { callback(); }

                kendoWindow
                    .find(".confirm-ok")
                        .click(function() {
                            kendoWindow.data("kendoWindow").close().destroy();
                        })
                        .end()
            },
            openRename: function (data, isFolder, callback) {

                var self = this;

                var kendoWindow = $('<div id="renameWindow" />').kendoWindow({
                    resizable: false,
                    modal: true,
                    dragend: () => { self.restrictWindowDragging('renameWindow') },
                    close: function (e) {
                        kendoWindow.data("kendoWindow").destroy();
                    },
                    activate: function () {
                        var el = document.getElementById('renameValue');

                        el.focus();

                        if (typeof el.selectionStart !== "undefined") {
                            el.selectionStart = 0;
                            el.selectionEnd = el.value.lastIndexOf('.') > -1 ? el.value.lastIndexOf('.') : el.value.length;
                        }

                        $('.k-overlay').attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');

                        $('#renameWindow').parent().attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                    }
                });

                var loginError = '&nbsp';
                var initialValue = data.Type ? data.Name + '.' + data.Type : data.Name;

                kendoWindow.data("kendoWindow")
                    .title(isFolder ? 'Rename Folder' : 'Rename File')
                    .content('<div id="changePassword" style="background-color:#333;padding: 10px 30px 25px 30px;width:400px">' +
                                '<div id="fpError" class="login-error" style="padding:0;margin:0;">' + loginError + '</div>' +
                               '<div><input id="renameValue" class="login-input" type="text" value="' + initialValue + '" style="width:100%" /></div>' +
                              '<div style="width:100%;text-align:center;">' +
                                '<input id="cp-submit" type="button" style="width:150px" class="login-button" value="Rename"><br/>' +
                                '</div></div>' +
                                '<style>.k-window-content { padding: 0 !important; }</style>')
                    .center().open();

                kendoWindow
                    .find("#cp-submit")
                        .click(function () {

                            $("#cp-submit").attr('disabled', true).addClass('disabled');
                            $("#renameValue").attr('disabled', true).addClass('disabled')

                            var closeWindow = function () {
                                kendoWindow.data("kendoWindow").close().destroy();
                            }

                            var fullName = $('#renameValue').val();

                            if ($rootScope.view.toLowerCase() === 'projects' && isFolder) {

                                if (fullName.length > 50) {
                                    self.openNotification('The name has exceeded the maximum length of 50 characters.', function () {
                                        $("#cp-submit").removeAttr('disabled', true).removeClass('disabled');
                                        $("#renameValue").removeAttr('disabled', true).removeClass('disabled');
                                    })
                                } else {

                                    if (initialValue === fullName) { kendoWindow.data("kendoWindow").close().destroy(); return false; }

                                  Project.rename(data.ID, fullName).then(function (res) {
                                    kendoWindow.data("kendoWindow").close().destroy();
                                    if (res.data.Error) {
                                          self.openNotification(res.data.Message);
                                        } else {
                                            callback(data.NodeIndex, fullName);
                                        }
                                    })
                                }

                            } else {
                                var hasExt = fullName.indexOf('.') > -1;
                                var newName = hasExt ? fullName.substr(0, fullName.lastIndexOf('.')) : fullName;
                                var newExt = hasExt ? fullName.substr(fullName.lastIndexOf('.') + 1) : '';

                                if (initialValue === fullName) { kendoWindow.data("kendoWindow").close().destroy(); return false; }

                                if (isFolder) {
                                    Folder.rename(data.ID, fullName).then(function (data) {
                                        if (data.Error) {
                                            self.openNotification(data.Message, closeWindow);
                                        } else {
                                            kendoWindow.data("kendoWindow").close().destroy();
                                            callback(data.NodeIndex, fullName);
                                        }
                                    })
                                } else {

                                    var renameFile = function () {
                                        File.rename(data.ID, newExt, newName).then(function (data) {
                                            if (data.Error) {
                                                self.openNotification(data.Message, closeWindow);
                                            } else {
                                                kendoWindow.data("kendoWindow").close().destroy();
                                                callback(fullName);
                                            }
                                        })
                                    }

                                    if (data.Type !== newExt) {
                                        self.openConfirmation('Changing the extension name will cause problems with launching the document.<br>' +
                                                                'Rendered documents extensions will not be changed.<br>' +
                                                                'Are you sure you wish to continue?', renameFile, closeWindow)
                                    } else {
                                        renameFile()
                                    }
                                }
                            }
                        })
                        .end()

                kendoWindow.keyup(function (e) {
                    if (e.which === 13) {
                        $("#cp-submit").click();
                    }

                    var input = angular.element('#renameValue');
                    input.val().length === 0 ? $("#cp-submit").attr('disabled', true).addClass('disabled') : $("#cp-submit").removeAttr('disabled').removeClass('disabled');
                });
            },
            restrictWindowDragging: function (windowName) {
                var winObject = $('#' + windowName).data("kendoWindow");

                var windowWrapper = winObject.wrapper,
                    windowPosition = windowWrapper.offset(),
                    shouldOverridePosition = false

                if (windowPosition.top > $(window).height() - windowWrapper.outerHeight()) {
                    shouldOverridePosition = true;
                }

                if (windowPosition.left > $(window).width() - windowWrapper.width()) {
                    shouldOverridePosition = true;
                }

                if (windowPosition.left < 0) {
                    shouldOverridePosition = true;
                }

                if (shouldOverridePosition) {
                    winObject.center();
                    winObject.refresh();
                }
            }
        };
    }
]);

